export const structure = {
    "VERTICAL": "Вертикальная",
    "HORIZONTAL": "Горизонтальная",
    "NOT_TEXTURAL": "Без текстуры",
}